// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Person_wrapper__2bT1F","leftSide":"Person_leftSide__27aYx","rightSide":"Person_rightSide__VcPTS","banner":"Person_banner__1diZ3","motto":"Person_motto__3OPFf"};